import { Component, Input } from '@angular/core';
import { FPAPipe } from '../pipes/fpa.pipe';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { TableModule } from 'primeng/table';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Deal } from '../model';
import { ToolbarModule } from 'primeng/toolbar';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-deal-products',
  standalone: true,
  imports: [
    TranslateModule,
    CommonModule,
    TableModule, ToolbarModule, ButtonModule,
    CurrencyPipe, FPAPipe
  ],
  templateUrl: './deal-products.component.html',
  styleUrl: './deal-products.component.scss'
})
export class DealProductsComponent {

  @Input()
  deal: Deal | null = null;

  constructor(protected translateService: TranslateService) {

  }
}
